import React from 'react';
import TransferList from '../transferList';
import { motivosPh3aProcessosEnum } from '../../../../shared/constantes/motivosPh3aProcessosEnum';
import { ParametroDefinicaoDTO } from '../integracaoInterfaces';

interface Ph3aJudicialProps {
    parametrosDefinicao: ParametroDefinicaoDTO[];
    motivosInternosPendencia: any[];
    motivosInternosReprova: any[];
    
    ph3aPendenciaSelecionados: any[];
    setPh3aPendenciaSelecionados: (v: any[]) => void;
    
    ph3aReprovaSelecionados: any[];
    setPh3aReprovaSelecionados: (v: any[]) => void;
    
    motivoInternoPendenciaId: string;
    setMotivoInternoPendenciaId: (v: string) => void;
    
    motivoInternoReprovaId: string;
    setMotivoInternoReprovaId: (v: string) => void;
}

const Ph3aJudicialCard: React.FC<Ph3aJudicialProps> = ({ 
    parametrosDefinicao, 
    motivosInternosPendencia, motivosInternosReprova,
    ph3aPendenciaSelecionados, setPh3aPendenciaSelecionados, 
    ph3aReprovaSelecionados, setPh3aReprovaSelecionados,
    motivoInternoPendenciaId, setMotivoInternoPendenciaId,
    motivoInternoReprovaId, setMotivoInternoReprovaId 
}) => {

    const getDisponiveisPendencia = () => {
        return motivosPh3aProcessosEnum.filter(m => 
            parametrosDefinicao.some(def => def.nomeParametro === m.descricaoBanco) &&
            !ph3aPendenciaSelecionados.includes(m) && 
            !ph3aReprovaSelecionados.includes(m)
        );
    };

    const getDisponiveisReprova = () => {
        return motivosPh3aProcessosEnum.filter(m => 
            parametrosDefinicao.some(def => def.nomeParametro === m.descricaoBanco) &&
            !ph3aPendenciaSelecionados.includes(m) && 
            !ph3aReprovaSelecionados.includes(m)
        );
    };

    return (
        <div className="card mb-4 shadow-sm">
            <div className="card-header bg-light fw-bold">Palavras-Chave PH3A Judicial</div>
            <div className="card-body">
                
                <div className="border rounded p-3 mb-3 bg-light-subtle">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="text-warning fw-bold m-0">Pendência</h6>
                        <div style={{width: '40%'}}>
                            <select 
                                className="form-select form-select-sm" 
                                value={motivoInternoPendenciaId} 
                                onChange={e => setMotivoInternoPendenciaId(e.target.value)}
                            >
                                <option value="">Selecione Ação de Pendência...</option>
                                {motivosInternosPendencia.map(m => <option key={m.id} value={m.id}>{m.descricao}</option>)}
                            </select>
                        </div>
                    </div>
                    <TransferList 
                        itemsDisponiveis={getDisponiveisPendencia()}
                        itemsSelecionados={ph3aPendenciaSelecionados}
                        displayField="motivo"
                        onChange={setPh3aPendenciaSelecionados}
                        tituloDisponiveis="Motivo Judicial Disponível"
                        tituloSelecionados="Motivo Judicial Selecionado para Pendência"
                    />
                </div>

                <div className="border rounded p-3 bg-light-subtle">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="text-danger fw-bold m-0">Reprova</h6>
                        <div style={{width: '40%'}}>
                            <select 
                                className="form-select form-select-sm" 
                                value={motivoInternoReprovaId} 
                                onChange={e => setMotivoInternoReprovaId(e.target.value)}
                            >
                                <option value="">Selecione Ação de Reprova...</option>
                                {motivosInternosReprova.map(m => <option key={m.id} value={m.id}>{m.descricao}</option>)}
                            </select>
                        </div>
                    </div>
                    <TransferList 
                        itemsDisponiveis={getDisponiveisReprova()}
                        itemsSelecionados={ph3aReprovaSelecionados}
                        displayField="motivo"
                        onChange={setPh3aReprovaSelecionados}
                        tituloDisponiveis="Motivo Judicial Disponível"
                        tituloSelecionados="Motivo Judicial Selecionado para Reprova"
                    />
                </div>
            </div>
        </div>
    );
};

export default Ph3aJudicialCard;